._UserDetails_1kcv7_1 {
  /* Empty file & class, used as a placeholder for future styling */
}